import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty, isNil, times } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';

import Row from './Row';

export const ResultsTable = ({ policies, onSelect }) => {
	const renderEmptyRow = () => (
		<TableRow>
			{times(
				(i) => (
					<TableCell key={i}>---</TableCell>
				),
				4,
			)}
		</TableRow>
	);

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>{getLabelMessage('policySearch:policyNo')}</TableCell>
					<TableCell>{getLabelMessage('policySearch:insurer')}</TableCell>
					<TableCell>{getLabelMessage('policySearch:insurance')}</TableCell>
					<TableCell>{getLabelMessage('policySearch:policyNoState')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{isNil(policies) ? (
					renderEmptyRow()
				) : isEmpty(policies) ? (
					<TableHasNoResults />
				) : (
					policies.map((policy, index) => (
						<TableRow key={index}>
							<Row policy={policy} onSelect={onSelect} index={index} />
						</TableRow>
					))
				)}
			</TableBody>
		</Table>
	);
};

ResultsTable.propTypes = {
	onSelect: PropTypes.func,
	policies: PropTypes.array,
};

export default ResultsTable;
